<template>
  <v-list-item dense class="py-0" style="overflow: visible">

    <v-list-item-avatar>
      <v-tooltip top>
        <template v-slot:activator="{on}">
          <v-icon v-on="on" >{{icon}}</v-icon>
        </template>
        <span>{{label}}</span>
      </v-tooltip>
    </v-list-item-avatar>

    <v-list-item-content style="overflow-x: auto">
      <v-list-item-title style="overflow: visible">
        <slot name="content">
          {{content}}
        </slot>
      </v-list-item-title>
    </v-list-item-content>

    <v-list-item-action v-if="!hideActions">
      <slot name="actions" />
    </v-list-item-action>

  </v-list-item>
</template>

<script>
export default {
  name: "AppointmentDetailsSection",
  props:{
    hideActions:{
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    content: {
      type: String,
    }
  }
}
</script>

<style scoped>

</style>
